import { motion } from "framer-motion";
import CountUp from "react-countup";
import { useTranslation } from "react-i18next";
import { FaPlus } from "react-icons/fa";
import { I18N_KEYS } from "../languages/PlaceHolder.js";

const Achievements = () => {
    const { t } = useTranslation()
    const stats = [
        { number: "1500", label: t(I18N_KEYS.STUDENTS) },
        { number: "120", label: t(I18N_KEYS.STAFF) },
        { number: "20", label: t(I18N_KEYS.YEARSOFEXP) },
        { number: "50", label: t(I18N_KEYS.STUDENTINMBBS) },
        { number: "100", label: t(I18N_KEYS.STUDENTINJEE) }
    ];

    return (<>
        <section className="py-32 bg-primary relative overflow-hidden">
            <div className="absolute top-0 left-0 w-full h-full opacity-10 pointer-events-none">
                <div className="absolute rotate-45 -top-20 -left-20 w-64 h-64 bg-accent" />
                <div className="absolute rotate-45 -bottom-20 -right-20 w-96 h-96 bg-accent" />
            </div>

            <div className="common-container relative z-10 text-center">
                <h2 className="text-4xl font-bold text-accent mb-20">{t(I18N_KEYS.ACHIEVEMENTTITLE)}</h2>

                <div className="grid grid-cols-2 md:grid-cols-5 gap-8 text-center">
                    {stats.map((s, i) => (
                        <motion.div
                            key={i}
                            initial={{ opacity: 0, scale: 0.5 }}
                            whileInView={{ opacity: 1, scale: 1 }}
                            viewport={{ once: true }}
                            transition={{ delay: i * 0.1 }}
                            className="flex flex-col items-center p-4"
                        >
                            <motion.h3 className="flex items-center text-4xl md:text-5xl font-black text-secondary mb-2 gap-1">
                                <CountUp start={0} end={s.number} duration={5} separator="," />
                                <FaPlus className="inline-block" size={25} />
                            </motion.h3>
                            <p className="text-accent font-medium text-sm md:text-base uppercase tracking-wider">
                                {s.label}
                            </p>
                        </motion.div>
                    ))}
                </div>

            </div>
        </section></>)
}

export default Achievements;